<h1 mat-dialog-title><b *ngIf="data.selection?.count > 0">{{ 'ALDEN.DIALOGS.EXCEL_EXPORT.TITLE_SELECTED' | translate }}</b><b
        *ngIf="data.selection?.count == 0">{{ 'ALDEN.DIALOGS.EXCEL_EXPORT.TITLE_ALL' | translate }}</b></h1>
<mat-dialog-content>
    <div class="custom-mat-dialog-content">
        <mat-icon *ngIf="data.selection?.count == 0" class="custom-mat-icon" color="warn">warning</mat-icon>
        <span *ngIf="data.selection?.count == 1"><b>{{ data.selection?.count}} {{ 'ALDEN.DIALOGS.EXCEL_EXPORT.SELECTED_DOCUMENT' | translate }}</b></span>
        <span *ngIf="data.selection?.count > 1"><b>{{ data.selection?.count}} {{ 'ALDEN.DIALOGS.EXCEL_EXPORT.SELECTED_DOCUMENTS' | translate }}</b></span>
        <span *ngIf="data.selection?.count > 0"><i>{{ 'ALDEN.DIALOGS.EXCEL_EXPORT.ONLY_SELECTED' | translate }}</i></span>
        <span *ngIf="data.selection?.count == 0">{{ 'ALDEN.DIALOGS.EXCEL_EXPORT.NO_SELECTION' | translate }} <br><b><i>{{ 'ALDEN.DIALOGS.EXCEL_EXPORT.ALL_DOCUMENTS_TOTAL' | translate:{ total: data.totalItems } }}</i></b></span>
        <br />
        <span>{{ 'ALDEN.DIALOGS.EXCEL_EXPORT.CONTINUE' | translate }}</span>
    </div>
    <div class="spinner-center" *ngIf="downloading">
        <mat-spinner></mat-spinner>
    </div>

</mat-dialog-content>
<mat-dialog-actions>
    <button mat-raised-button color="accent" mat-dialog-close [disabled]="downloading">
        {{ 'ALDEN.DIALOGS.EXCEL_EXPORT.CANCEL' | translate }}
    </button>
    <button *ngIf="!downloading" mat-raised-button color="primary" (click)="download()" >
        {{ 'ALDEN.DIALOGS.EXCEL_EXPORT.EXPORT' | translate }}
    </button>
</mat-dialog-actions>
